import React, { useEffect, useState } from "react";
import TypedText from "../components/TypedText";

const SplashScreen = () => {
  const [fade, setFade] = useState(false);
  const [typingComplete, setTypingComplete] = useState(false);

  useEffect(() => {
    // Only begin fade out after typing is complete
    if (typingComplete) {
      const timer = setTimeout(() => {
        setFade(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [typingComplete]);

  return (
    <div className={`splash-screen ${fade ? "fading" : "visible"}`}>
      <h1>
        <TypedText 
          text="Welcome..." 
          speed={150} 
          cursorColor="black"
          onComplete={() => setTypingComplete(true)} 
        />
      </h1>
    </div>
  );
};

export default SplashScreen;
